export default __webpack_public_path__ + "static/media/ic_save.55d784dd.svg";